import { render, staticRenderFns } from "./education_background.vue?vue&type=template&id=384b2aa8&"
import script from "./education_background.vue?vue&type=script&lang=js&"
export * from "./education_background.vue?vue&type=script&lang=js&"
import style0 from "./education_background.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports